<template>
    <el-dialog class="el-dialogs" :append-to-body="true" title="选择联系人" width="800px"
               :close-on-click-modal="false"
               :visible.sync="visible">
        <el-row :gutter="10">
            <el-col :span="12">
                <div class="borderStyle">
                    <div class="contentData matTop" v-loading="loading">
                        <el-input
                                size="mini"
                                placeholder="搜索用户"
                                suffix-icon="el-icon-search"
                                @input="searchTree"
                                v-model="keyWorld">
                        </el-input>
                        <el-tree
                                :data="treeData"
                                show-checkbox ref="selectTree"
                                node-key="id" :check-strictly="true"
                                :default-expand-all="true"
                                @check-change="handleCheckNode"
                                :filter-node-method="filterNode"
                                :props="defaultProps">
                        </el-tree>
                    </div>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="borderStyle">
                    <div class="bodTitle">已选：{{ selectNodes.length }}个</div>
                    <div class="contentData matTop contentData2">
                        <div class="flex_b_c itemUser" v-for="item in selectNodes" :key="item.id">
                            <div class="omit namem">{{ item.departmentName }}</div>
                            <div @click="deleteTag(item)" class="el-icon-close denagpja"></div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "contacts",
    data() {
        return {
            visible: false,
            loading: false,
            keyWorld: '',
            treeData: [],
            defaultProps: {
                children: 'children',
                label: 'departmentName'
            },
            selectNodes: [],
            selectData: [],
        }
    },
    methods: {
        init(selectData) {
            this.visible = true
            this.keyWorld = ''
            this.treeData = []
            this.selectNodes = selectData
            this.selectData = selectData
            this.getOthers()
        },

        getOthers() {
            this.loading = true
            this.$axios(this.api.user.sysdepartmentGetDepartmentUserList, {}, 'get').then(data => {
                if (data && data.status) {
                    this.loading = false
                    this.treeData = this.setTreeData(data.data)
                    if (this.selectData) {
                        this.$nextTick(() => {
                            let ids = this.selectData.map(item => item.id)
                            this.$refs.selectTree.setCheckedKeys(ids)
                        })
                    }
                }
            })
        },

        setTreeData(list) {
            if (list.length == 0) return
            list.forEach(item => {
                this.$set(item, 'disabled', true)
                if (item.userChildren.length) {
                    item.children = item.userChildren.map(item2 => {
                        this.$set(item2, 'departmentName', item2.name)
                        return item2
                    })
                } else {
                    item.children = this.setTreeData(item.children)
                }
            })
            return list
        },

        searchTree() {
            this.$refs.selectTree.filter(this.keyWorld);
        },

        filterNode(value, data) {
            if (!value) return true;
            return data.departmentName.indexOf(value) !== -1;
        },

        handleCheckNode() {
            this.selectNodes = this.$refs.selectTree.getCheckedNodes()
        },

        deleteTag(row) {
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.selectNodes = this.selectNodes.filter(item => {
                    if (item.id == row.id) {
                        this.$refs.selectTree.setChecked(item.id)
                    }
                    return item.id != row.id
                })

            })
        },

        doSubmit() {
            if (this.selectNodes.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            this.$emit('selectuserData', this.selectNodes)
            this.visible = false
        },
    }
    ,
}
</script>

<style scoped>
.borderStyle {
    border: 1px solid #EBEBEB;
    padding: 10px;
    border-radius: 10px;

    .bodTitle {
        font-size: 14px;
        font-weight: bold;
    }
}

.contentData {
    height: 380px;
    overflow-y: auto;
}

.contentData2 {
    height: 359px;
}

.matTop {
    margin-top: 10px;
}

.itemUser {
    margin: 5px 5px;
    padding: 5px 10px;
    border: 3px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;

    .namem {
        width: 80%;
    }

    .denagpja {
        cursor: pointer;
    }
}
</style>